"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mkBattery = void 0;
var _Observable = require("../Observables/Observable");
var mkBattery = exports.mkBattery = function mkBattery() {
  return (0, _Observable.mkObservable)(function (observer) {
    if (!navigator.getBattery) {
      observer.error('navigator.getBattery not supported');
    } else {
      navigator.getBattery().then(function (battery) {
        var next = function next() {
          observer.next({
            charging: battery.charging,
            chargingTime: battery.chargingTime,
            level: battery.level
          });
        };
        next();
        battery.addEventListener("chargingchange", next);
        battery.addEventListener("chargingtimechange", next);
        battery.addEventListener("dischargingtimechange", next);
        battery.addEventListener("levelchange", next);
      })["catch"](function (ex) {
        observer.error('navigator.getBattery promise failed');
      });
    }
  });
};